import getTheme from './getTheme';

const getDefaultTheme = (site?: Site) => {
  switch (site) {
    case 'sportsbet':
      return getTheme('sportsbetDark');
    case 'sportsbetmx':
      return getTheme('sportsbetDark');
    case 'livecasino':
      return getTheme('livecasinoDark');
    case 'empire':
      return getTheme('empireDark');
    default:
      return getTheme('bitcasinoDark');
  }
};

export default getDefaultTheme;
